import { jsx as _jsx } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { DocumentEditor } from '@onlyoffice/document-editor-react';
import { useEffect, useMemo } from 'react';
/** Bookmark names Specra stamps on headings (WRT §3.3): hidden `_spx_…` or visible `spx_…`. */ export const ANCHOR_PATTERN = /^_?spx_[0-9a-f]{32}$/;
/** Parses the signed config and adds the bookmark action link. null = unparseable. */ export function buildEditorConfig(editorConfigJson, anchor) {
    let config;
    try {
        config = JSON.parse(editorConfigJson);
    } catch  {
        return null;
    }
    if (!config || typeof config !== 'object') return null;
    if (anchor && ANCHOR_PATTERN.test(anchor)) {
        const editorConfig = config.editorConfig ?? {};
        if (!editorConfig.actionLink) {
            config = {
                ...config,
                editorConfig: {
                    ...editorConfig,
                    actionLink: {
                        action: {
                            type: 'bookmark',
                            data: anchor
                        }
                    }
                }
            };
        }
    }
    return config;
}
/**
 * The one host for `<DocumentEditor>` (WRT-04): moved out of
 * `VolumeDocumentEditor`'s inner `OnlyOfficeEmbed`, without the dead
 * `createConnector()` registration (R-1). The parent remounts it (React `key`)
 * to load a new document key, a version view or a new anchor.
 */ export function OfficeEditorFrame({ anchor, editorId, onDocumentReady, onDocumentStateChange, onError, onInfo, onRequestUsers, ready = false, session, testId }) {
    const config = useMemo(()=>buildEditorConfig(session.editorConfigJson, anchor), [
        session.editorConfigJson,
        anchor
    ]);
    useEffect(()=>{
        if (!config) onError?.({
            data: {
                errorDescription: 'unparseable editor config'
            }
        });
    }, [
        config,
        onError
    ]);
    if (!config) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex h-full flex-col",
        "data-testid": testId,
        children: /*#__PURE__*/ _jsx("div", {
            className: "min-h-0 flex-1",
            "data-editor-ready": ready,
            "data-testid": Testids.volume.onlyOfficeFrame,
            children: /*#__PURE__*/ _jsx(DocumentEditor, {
                config: config,
                documentServerUrl: session.documentServerUrl,
                events_onDocumentReady: onDocumentReady,
                events_onDocumentStateChange: onDocumentStateChange,
                events_onError: onError,
                events_onInfo: onInfo,
                events_onRequestUsers: onRequestUsers,
                id: editorId,
                onLoadComponentError: (errorCode, errorDescription)=>onError?.({
                        data: {
                            errorCode,
                            errorDescription
                        }
                    })
            })
        })
    });
}
